import { createContext } from 'react';
import type { WorkspaceContextType } from './workspaceTypes';

export const WorkspaceContext = createContext<WorkspaceContextType | undefined>(undefined);
